const BulletList = ({ children }) => {
	return <ul>{children}</ul>;
};

export default BulletList;
